import e from"../createStyled/createStyled.js";var t=e();export{t as default};
//# sourceMappingURL=styled.js.map
